import React from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import useListCmsPaginatedContents from 'hooks/useListCmsPaginatedContents'
import HeaderWithBackButton from 'redesign/components/organisms/headers/header-with-back-button'
import Page from 'redesign/components/templates/Page'
import NewsletterContent from 'redesign/components/templates/newsletter-content'
import type { OwnerIdPageProps } from 'redesign/shared/types'
import { CONTENT_TYPES } from 'types/cms'

const NewsletterPage: React.FC<OwnerIdPageProps> = ({ match }) => {
  const { t } = useFavurTranslation()
  const {
    params: { ownerId },
  } = match
  const owner = parseInt(ownerId)

  const { list, loading, hasMoreElements, loadMore } = useListCmsPaginatedContents({
    contentType: CONTENT_TYPES.newsletter,
    ownerId: owner,
  })

  return (
    <Page header={<HeaderWithBackButton title={t('page.cms.newsletter.header')} />}>
      <NewsletterContent
        newsletters={list}
        loading={loading}
        showLoadMoreElements={hasMoreElements}
        loadMore={loadMore}
      />
    </Page>
  )
}

export default NewsletterPage
